var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettings2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19668"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 6401"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14642"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10.91 2.184h2.181c1.086.422 1.344.81 1.349 2a7 7 0 0 0 .045 1.043 1.616 1.616 0 0 0 2.33 1.18c.348-.179.681-.388 1.02-.585a1.544 1.544 0 0 1 2.253.538c.287.453.555.918.82 1.385a1.54 1.54 0 0 1-.519 2.165c-.327.216-.679.392-1.011.6a1.682 1.682 0 0 0 .005 2.9c.258.161.529.3.79.458a1.674 1.674 0 0 1 .851 2.034 9.5 9.5 0 0 1-.908 1.769 1.57 1.57 0 0 1-2.281.587c-.328-.186-.649-.385-.983-.561a1.607 1.607 0 0 0-2.373 1.2 12 12 0 0 0-.041 1.261 1.62 1.62 0 0 1-1.656 1.656 35 35 0 0 1-1.525 0 1.63 1.63 0 0 1-1.7-1.707 11 11 0 0 0-.043-1.3 1.616 1.616 0 0 0-2.307-1.227c-.379.183-.751.379-1.125.571a1.54 1.54 0 0 1-2.176-.594 34 34 0 0 1-.819-1.385 1.537 1.537 0 0 1 .524-2.163c.314-.207.649-.383.973-.575a1.612 1.612 0 0 0 .012-2.848c-.262-.156-.531-.3-.792-.456a1.77 1.77 0 0 1-.653-2.488q.355-.625.731-1.236a1.58 1.58 0 0 1 2.217-.618c.362.182.721.371 1.086.548a1.617 1.617 0 0 0 2.334-1.23 7 7 0 0 0 .037-.912c.011-1.205.268-1.588 1.354-2.01m4.359 9.833a3.269 3.269 0 1 0-3.277 3.249 3.26 3.26 0 0 0 3.275-3.249Z",
  "data-name": "Path 16661"
})))));
export { SvgSettings2 as ReactComponent };
export default __webpack_public_path__ + "static/media/settings2.b77a6b42c8fcd2949c92ba9288540a04.svg";